import React, { useContext, useState } from 'react';
import { Popover } from '@headlessui/react';
import { PlusIcon } from '@heroicons/react/24/outline';
import { AuthContext } from "../contexts/auth";
import { Link } from "wouter";
import DipendentiTable from "../components/dipendenti_table";
import { importEmployees } from '../services/api_import_employees';
import UploadForm from '../components/upload_form';
import PopoverComponentCustom from '../components/popover_component';
import Footer from '../components/footer';



export default function EmployeeList() {
  const resourceType = 'dipendenti'

  const { profile, token } = useContext(AuthContext)

  // const updateData = () => {
  //   console.log('updateData')
  //   // emit an event to update the data
  //   window.dispatchEvent(new Event('updateDataHR'))
  // }

  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [file, setFile] = useState(null);
  
  const isProfileComplete = profile.has_complete_profile;

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const handleImport = async () => {
    if (selectedFile) {
        setLoading(true);
        try {
            await importEmployees(token, selectedFile, 'payrolls');
            console.log('Importazione completata con successo!');
            
        } catch (error) {
            console.log('Errore durante l\'importazione dei dipendenti.');
            console.error(error);
        } finally {
            setLoading(false);
        }
    } else {
        alert('Seleziona un file CSV prima di importare.');
    }
};


  return <>
    <div className="flex flex-col min-h-screen">
      <PopoverComponentCustom title="Lista Dipendenti" />
      {profile?.customer_type === 'company' && !isProfileComplete && profile?.company?.email == profile?.the_real_user_email && (
        <div className="w-full">
          <div className="bg-orange-100 text-orange-600 p-4 mb-6">
            <p className="text-center text-sm font-semibold">
              Il profilo non è completo. <br />
              Compila i campi mancanti{' '}
              <Link
                to="/profilo/fatturazione"
                className="text-indigo-600 hover:text-indigo-800 underline"
              >
                cliccando qui
              </Link>
            </p>
          </div>
        </div>
      )}
      <main className="mt-10 pb-8 flex-grow">
        <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:max-w-7xl lg:px-8">
        {/* <div className="ml-auto">
              <Link
                to="/upload_csv"
                className={`inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
              >
                Importa dipendenti
                <PlusIcon className="-mr-0.5 h-5 w-5" />
              </Link>
            </div> */}
          <div>
            <DipendentiTable loading={true} token={token} company_id={profile.company.id} />
          </div>
        </div>

        {isModalOpen && (

          <div className="fixed rounded-lg inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="bg-white rounded-lg max-w-md w-full">
              <h2 className="text-lg rounded-t-lg font-semibold mb-4 text-indigo-800 text-center bg-indigo-100 py-3">Importa Dipendenti</h2>
              <input
                type="file"
                accept=".csv"
                className="block file:py-6 w-full mx-4 border border-gray-200 mb-4 text-sm text-slate-500
                  file:mr-4 file:px-4
                  file:rounded-75 file:border-0
                  file:text-sm file:font-semibold
                  file:bg-indigo-50 file:text-indigo-700
                  hover:file:bg-indigo-100
                "
                onChange={handleFileChange}
              />
              <div className="flex justify-end">
                <button
                  onClick={() => {
                    handleImport();
                    setIsModalOpen(false);
                  }}
                  className={`inline-flex items-center gap-x-1.5 rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600`}
                >
                  Conferma
                </button>
                <button
                  onClick={() => setIsModalOpen(false)}
                  className="ml-2 inline-flex items-center gap-x-1.5 rounded-md bg-gray-400 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-gray-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gray-600"
                >
                  Annulla
                </button>
              </div>
            </div>
          </div>


        )}
      </main>
      <Footer />
    </div>
  </>;
}